import React from 'react';

export const Card = ({ children, className, ...props }) => (
  <div
    className={`bg-blanco-nieve border border-gris-pizarra shadow-md rounded-lg p-4 ${className}`}
    {...props}
  >
    {children}
  </div>
);

export const CardContent = ({ children, className, ...props }) => (
  <div className={`text-azul-lago ${className}`} {...props}>
    {children}
  </div>
);

export const CardDescription = ({ children, className, ...props }) => (
  <p className={`text-gris-pizarra text-sm ${className}`} {...props}>
    {children}
  </p>
);

export const CardHeader = ({ children, className, ...props }) => (
  <div className={`border-b border-gris-pizarra mb-2 pb-2 ${className}`} {...props}>
    {children}
  </div>
);

export const CardTitle = ({ children, className, ...props }) => (
  <h3 className={`text-xl font-bold text-azul-lago ${className}`} {...props}>
    {children}
  </h3>
);

export const CardFooter = ({ children, className, ...props }) => (
  <div className={`mt-4 pt-2 border-t border-gris-pizarra ${className}`} {...props}>
    {children}
  </div>
);
